import React from 'react';

const ResponseCounter = ({ responsesRemaining, showUpgradePrompt }) => {
  if (responsesRemaining === null || responsesRemaining === undefined) return null;

  const percentage = ((7 - responsesRemaining) / 7) * 100;
  const isLow = responsesRemaining <= 2;

  return (
    <div style={{
      backgroundColor: 'white',
      border: `3px solid ${isLow ? '#ff4444' : '#4A90E2'}`,
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      minWidth: '280px',
      animation: isLow ? 'pulse 2s infinite' : 'none'
    }}>
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px'
        }}>
          <span style={{
            fontWeight: '700',
            fontSize: '16px',
            color: '#333'
          }}>
            🎁 Free Trial
          </span>
          <span style={{
            fontWeight: '700',
            fontSize: '18px',
            color: isLow ? '#ff4444' : '#4A90E2'
          }}>
            {responsesRemaining}/{7}
          </span>
        </div>
        
        <div style={{
          width: '100%',
          height: '8px',
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${percentage}%`,
            height: '100%',
            backgroundColor: isLow ? '#ff4444' : '#4A90E2',
            transition: 'width 0.3s ease',
            borderRadius: '4px'
          }} />
        </div>
        
        <div style={{
          fontSize: '13px',
          color: '#666',
          marginTop: '6px'
        }}>
          {responsesRemaining === 0 ? '❌ Trial exhausted' : 
           responsesRemaining === 1 ? '⚠️ Last response remaining!' :
           `✅ ${responsesRemaining} responses left`}
        </div>
      </div>

      {showUpgradePrompt && (
        <div style={{
          marginTop: '12px',
          padding: '12px',
          backgroundColor: '#E3F2FD',
          borderRadius: '8px',
          border: '2px solid #4A90E2'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#1565C0',
            marginBottom: '8px',
            fontWeight: '600'
          }}>
            ✨ Loving Emit? Get unlimited access!
          </p>
          <button style={{
            fontSize: '13px',
            fontWeight: '700',
            color: '#4A90E2',
            background: 'white',
            border: '2px solid #4A90E2',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            width: '100%'
          }}>
            View Plans →
          </button>
        </div>
      )}
    </div>
  );
};

export default ResponseCounter;
